<mat-toolbar>
  <mat-toolbar-row>
    <div class="menu-container">
      <div class="menu-container__logo">
        <img ngSrc="images/logo/logo-navbar.svg" alt="Logo" height="40" width="136" priority />
      </div>
      <div class="menu-container__actions">
        <i class="fa-regular fa-user" routerLink="/profile" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"></i>
        <i class="fa-solid fa-arrow-right-from-bracket" (click)="logout()"></i>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
